/// <amd-module name="VSS/Redux/Registry" />
import { IObservableObject, ObservableObject } from "VSS/Core/Observable";

// Global function registry
export const Selectors: IObservableObject<Function> = new ObservableObject<Function>();
